// Haversine formula for calculating distance between two GPS coordinates
export function calculateDistance(lat1, lon1, lat2, lon2) {
  if (!lat1 || !lon1 || !lat2 || !lon2) return null;
  
  const R = 6371; // Earth's radius in kilometers
  const dLat = toRad(lat2 - lat1);
  const dLon = toRad(lon2 - lon1);
  
  const a = 
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) *
    Math.sin(dLon / 2) * Math.sin(dLon / 2);
  
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  const distance = R * c;
  
  return Math.round(distance * 10) / 10; // Round to 1 decimal place
}

function toRad(deg) {
  return deg * (Math.PI / 180);
}

// Get and cache buyer location in sessionStorage
export async function getBuyerLocation() {
  // Check cache first
  const cached = sessionStorage.getItem('buyerLocation');
  if (cached) {
    try {
      return JSON.parse(cached);
    } catch {
      // Invalid cache, proceed to get fresh
    }
  }
  
  // Get fresh location
  if (!navigator.geolocation) return null;
  
  try {
    const position = await new Promise((resolve, reject) => {
      navigator.geolocation.getCurrentPosition(resolve, reject, {
        enableHighAccuracy: false,
        timeout: 5000,
        maximumAge: 300000 // 5 minutes cache
      });
    });
    
    const location = {
      latitude: position.coords.latitude,
      longitude: position.coords.longitude
    };
    
    // Cache for session
    sessionStorage.setItem('buyerLocation', JSON.stringify(location));
    return location;
  } catch {
    return null;
  }
}

// Format distance for display
export function formatDistance(distance, isArabic = false) {
  if (distance === null || distance === undefined) return null;
  
  if (isArabic) {
    return `📍 يبعد ${distance} كم`;
  }
  return `📍 ${distance} km away`;
}
